import {
  userReducer,
  employeeReducer,
  userRoleReducer,
  sessionConfigReducer,
  quoteApprovalDetailsReducer,
  reqtCategoryListReducer,
  locationListReducer,
  icabsProductListReducer,
  icabsProductDetailListReducer,
  infestationLevelListReducer,
  icabsProductCoverListReducer,
  pezodeUnitListReducer
} from "./slice-index";

import { combineReducers, configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";

const appReducer = combineReducers({
  userSlice: userReducer,
  employeeSlice: employeeReducer,
  userRoleSlice: userRoleReducer,
  sessionConfigSlice: sessionConfigReducer,
  quoteApprovalDetailsSlice: quoteApprovalDetailsReducer,
  reqtCategoryListSlice: reqtCategoryListReducer,
  locationListSlice: locationListReducer,
  icabsProductListSlice: icabsProductListReducer,
  icabsProductDetailListSlice: icabsProductDetailListReducer,
  infestationLevelListSlice: infestationLevelListReducer,
  icabsProductCoverListSlice: icabsProductCoverListReducer,
  pezodeUnitListSlice: pezodeUnitListReducer
});

const rootReducer = (state, action) => {
  if (action.type === "userSlice/clearUser") {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  whitelist: [
    "userSlice",
    "employeeSlice",
    "userRoleSlice",
    "sessionConfigSlice",
    "locationListSlice",
    "reqtCategoryListSlice",
    "icabsProductListSlice",
    "icabsProductDetailListSlice",
    "infestationLevelListSlice",
    "icabsProductCoverListSlice",
    "pezodeUnitListSlice"
  ],
};

const persistedReducers = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

const persiststore = persistStore(store);

export { store, persiststore };
